import { Routes } from '@angular/router';

// Shopper Components
import { ShopperLayoutComponent } from './components/shopper-layout/shopper-layout.component';
import { LoginComponent } from './components/login/login.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { AuthGuard, HomeGuardService } from './services/auth-guard.service';

export const shopperRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'onboarding',
    component: OnboardingComponent,
    canActivate: [AuthGuard()]
  },
  {
    path: '',
    component: ShopperLayoutComponent,
    canActivate: [AuthGuard(), HomeGuardService()]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
]; 